export default function DeliveryOptions({
    selected,
    onSelect,
    distanceKm,
    radiusKm,
    littleCabEnabled = false,
    fargoEnabled = false,
    manualDeliveryEnabled = true,
}) {
    const options = [];

    if (manualDeliveryEnabled) {
        options.push({
            id: 'manual',
            label: 'Delivery',
            sublabel: 'We deliver to your address',
            icon: '🚚',
            available: true,
            lockedReason: null,
        });
    }

    if (littleCabEnabled) {
        options.push({
            id: 'littlecab',
            label: 'Little Cab',
            sublabel: 'Same-day delivery',
            icon: '🚗',
            available: distanceKm == null || distanceKm <= radiusKm,
            lockedReason: distanceKm != null && distanceKm > radiusKm
                ? `Not available — your address is ${distanceKm} km away (max ${radiusKm} km)`
                : null,
        });
    }

    if (fargoEnabled) {
        options.push({
            id: 'fargo',
            label: 'Fargo Courier',
            sublabel: 'Standard delivery (1–3 days)',
            icon: '📦',
            available: true,
            lockedReason: null,
        });
    }

    if (options.length === 0) {
        return (
            <p className="text-xs text-amber-600 dark:text-amber-400">
                No delivery options are currently available. Please choose Pick Up from Store, or try again later.
            </p>
        );
    }

    return (
        <div className="space-y-3">
            {options.map((opt) => {
                const isSelected = selected === opt.id;
                const isDisabled = !opt.available;
                return (
                    <div
                        key={opt.id}
                        onClick={() => !isDisabled && onSelect(opt.id)}
                        className={`
                            flex items-center gap-3.5 px-4 py-3.5 rounded-xl border-2 transition-all cursor-pointer
                            ${isSelected
                                ? 'border-primary bg-primary/5 dark:bg-primary/10'
                                : isDisabled
                                    ? 'border-border bg-muted/30 opacity-50 cursor-not-allowed'
                                    : 'border-border bg-card hover:border-primary/50'}
                        `}
                    >
                        <span className="text-2xl">{opt.icon}</span>
                        <div className="flex-1">
                            <div className="font-semibold text-foreground">{opt.label}</div>
                            <div className="text-xs text-muted-foreground mt-0.5">
                                {opt.lockedReason || opt.sublabel}
                            </div>
                        </div>
                        <div
                            className={`
                                w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors
                                ${isSelected ? 'border-primary bg-primary' : 'border-muted-foreground/30 bg-transparent'}
                            `}
                        >
                            {isSelected && (
                                <div className="w-2 h-2 rounded-full bg-primary-foreground" />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
